import {
  Component,
  Inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  DnextRole,
  DoctorsNextService,
  GetDepartmentsResponse,
} from 'src/app/feature/doctors-next.service';

@Component({
  selector: 'app-doctors-next-select-departments',
  templateUrl: './doctors-next-select-departments.component.html',
  styleUrls: [
    './doctors-next-select-departments.component.css',
    '../style/index.css',
  ],
})
export class DoctorsNextSelectDepartmentsComponent
  implements OnInit, OnChanges
{
  @Input()
  role?: DnextRole;
  @Input()
  label?: string;
  @Input()
  clientId: string = '';

  departments?: GetDepartmentsResponse;

  _departments?: {
    category: GetDepartmentsResponse['department_categories'][0];
    departments: GetDepartmentsResponse['departments'][string];
  }[];
  selected: Record<string, boolean> = {};

  constructor(
    private dnextService: DoctorsNextService,
    private dialogRef: MatDialogRef<DoctorsNextSelectDepartmentsComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      role: DnextRole;
      selectedLabels: string[];
      label: string;
      clientId: string;
    }
  ) {
    this.role = this.data.role;
    this.label = this.data.label;
    this.clientId = this.data.clientId;
  }

  ngOnInit(): void {
    this.initialize();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initialize();
  }

  private initialize() {
    this.selected = {};
    if (!this.role) return;
    this.dnextService
      .getSpecialties(this.clientId, this.role)
      .subscribe((departments) => {
        this.departments = departments;
        this._departments = [];
        for (const category of departments.department_categories) {
          this._departments.push({
            category: category,
            departments: departments.departments[category],
          });
        }
      });
    for (const selectedLabel of this.data.selectedLabels) {
      this.selected[selectedLabel] = true;
    }
  }

  cancel() {
    this.dialogRef.close();
  }
  apply() {
    const selected = Object.keys(this.selected).filter(
      (label) => this.selected[label]
    );
    this.dialogRef.close(selected);
  }
}
